import { createStore } from 'vuex';
import helper from './modules/helper';
import page from './modules/page';
import user from './modules/user';
import enquete from './modules/enquete';

export default createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    helper,
    page,
    user,
    enquete,
  },
});
